// Module
var code = "<div class=\"overflow-hidden flex items-center justify-center m-12\"> <div class=\"loader ease-linear rounded-full border-2 border-t-2 border-gray-200 h-12 w-12\"></div> </div> ";
// Exports
export default code;